import React, { Component,useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Login } from "../../features/auth";
import { setCurrentUser } from '../../features/userSlice';
import { Link,useNavigate } from "react-router-dom";
import {Layout,Button,Row,Col,Typography,Form,Input,Switch,message,Spin,Alert,notification} from "antd";
import signinbg from "../../assets/images/c.jpg";
import { DribbbleOutlined, TwitterOutlined, InstagramOutlined, GithubOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { Header, Footer, Content } = Layout;


export default function SignIn (props) {
  const [loading, setLoading] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [notificationApi, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (notificationType, title, content) => {
    notificationApi.error({
      message: title,
      description: content,
      duration: 0,
      placement:'bottomLeft'
    });
  };
  
  const onFinishFailed = (errorInfo) => {
    message.error("Please fill the form correctly before submitting...");
  }; 
  const handleLogin = (username,password) => {
    setLoading(true);
    dispatch(Login({ username, password }))
      .unwrap()
      .then((response) => {
        setLoading(false);
        dispatch(setCurrentUser(response))
        // props.history.push("/");
        navigate("/profile");
      }).catch((error) => {
        console.log(error);
        setLoading(false);
        message.error("Either password or Email is incorrect, please use valid credentials. "+error);
        openNotificationWithIcon("error", "Error",  error);
      });
  };
    const onFinish = (values) => {
      const username = values.email;
      const password = values.password;
      handleLogin(username,password);
    };


    if (isLoggedIn) {
      navigate("/");
    }
    return (
      <>
        <Layout className="layout-default layout-signin">
          <Content className="signin">
            <Row gutter={[24, 0]} justify="space-around">
              <Col
                xs={{ span: 24, offset: 0 }}
                lg={{ span: 6, offset: 2 }}
                md={{ span: 12 }}
              >
                {contextHolder}
                <Title className="mb-15">Sign In</Title>
                <Spin spinning={loading} delay={5000} size='default' tip='Signing you In... Please wait'>
                <Form
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  layout="vertical"
                  className="row-col">
                  <Form.Item
                    className="username"
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your email and it must a valid!",
                      },{
                        pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                        message: <Alert  style={{marginTop:5}}message='please a enter a valid email' type="error" showIcon />,
                       }
                    ]}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>

                  <Form.Item
                    className="username"
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                        pattern: /^[A-Za-z]||[A-Za-z0-9_ ]||[@$!%*?&]{8,10}$/
                      },
                    ]}
                  >
                    <Input.Password placeholder="Password" />
                  </Form.Item>

                  <Form.Item
                    name="remember"
                    className="aligin-center"
                    valuePropName="checked">

                    <Switch defaultChecked  />
                    Remember me
                  </Form.Item>

                  <Form.Item>
                      {loading?<Button style={{ width: "100%",backgroundColor:'white',border:'1px solid #00b33c' }} disabled ></Button>:<Button
                      htmlType="submit"
                      style={{ width: "100%",backgroundColor:'#00b33c',color:'white' }}
                    >
                      SIGN IN
                    </Button>}

                  </Form.Item>
                  <p className="font-semibold text-muted">
                    Don't have an account?{" "}
                    <Link to="/SignUp" className="text-dark font-bold">
                      Sign Up
                    </Link>
                  </p>
                </Form>
                </Spin>
              </Col>
              <Col
                className="sign-img"
                style={{ padding: 12 }}
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                md={{ span: 12 }}
              >
                <img src={signinbg} style={{marginTop:0,height:'100%',}} alt="" />
              </Col>
            </Row>
          </Content>
        </Layout>
      </>
    );
  }
